import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BaseService } from './base.service';
import {DocumentType} from '../models/documentType.model';
import { Observable } from 'rxjs';
import { IQueryResult } from '../base/interfaces/IQueryResult';
import { AttributeReference } from '../models/documentTypeReference.model';

@Injectable()
export class DocumentTypeService extends BaseService<DocumentType> {
  /**
   *
   */
  constructor(
    http: HttpClient,
    @Inject('BASE_URL') rootUrl: string
  ) {
    super(http, rootUrl, 'DocumentType');
  }

  getReferences(): Observable<IQueryResult<AttributeReference>> {
    return this.http.get<IQueryResult<AttributeReference>>(`${this.rootUrl}/${this.endpoint}/references`);
  }
  recreateIndex(id: string): Observable<any> {
    return this.http.post(`${this.rootUrl}/${this.endpoint}/${id}/reindex`,null);
  }
  get EmptyReference(): AttributeReference {
    return {
      id: AttributeReference.GetEmptyGuid(),
      name: null,
      filter: null,
      apiPath: null
    };
  }
}
